export default {
  newDesign: true,
  parameters: {
    landing_id: "PlLongFC",
    segment: 7,
  },
  title: "Uwolnij talent swojego dziecka dzięki programowaniu | Kodland",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    footer: true,
    startBackground: "white",
    quizBackground: "#white",
    title:
      "Odpowiedz na pytania, aby otrzymać darmowy kurs programowania dla swojego dziecka",
    subtitle:
      "Pokażemy, jak zamienić pasję do gadżetów w zaletę:<br> 💬 Odkryj talenty swojego dziecka w zabawny sposób <br>🌐 Wszystko, czego potrzebujesz, to komputer i dostęp do internetu <br>💙 Zaufali nam już ponad 100 000 rodziców",
    image: {
      url: "/welcome/pl_longquiz_dev_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/pl_longquiz_dev_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Zaczynajmy! 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Dziękujemy za zaufanie naszej platformie edukacyjnej!",
    subtitle:
      "Niestety, tablety lub telefony nie nadają się do korzystania z naszych lekcji. Będziemy szczęśliwi, widząc Was na naszych zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      title: "Ile lat ma Twoje dziecko?",
      type: "age",
      button: "",
    },
    2: {
      question:
        "Ile czasu Twoje dziecko spędza na gadżetach (telefon, komputer lub tablet)?",
      answers: [
        "Mniej niż 1 godzina dziennie ",
        "1 do 4 godzin dziennie",
        "Więcej niż 4 godziny dziennie",
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
      subtitle: "Co czeka Twoje dziecko na lekcjach?<br>✅ Nauka podstaw programowania<br>✅ Tworzenie pierwszych projektów (gry, aplikacje, strony internetowe itp.)<br>✅ Rozwój myślenia logicznego<br><br>Dla niektórych stanie się to nowym, fajnym hobby, a dla innych będzie to pierwszy krok do przyszłego zawodu.",
      button: "Świetnie!",
    },
    4: {
      question:
        "Czy Twoje dziecko ma dostęp do laptopa lub komputera stacjonarnego do nauki?",
      answers: [
        "Tak, ma własne urządzenie 💻✅",
        "Tak, ale dzieli je z innymi 🖥️👫",
        {
          answer: "Nie, nie ma regularnego dostępu 🚫",
          stopAnswer: true,
        },
      ],
    },
    5: {
      question:
        "Jak Twoje dziecko najlepiej zapamiętuje lub uczy się nowych rzeczy?",
      answers: [
        "Poprzez oglądanie (uczeń wzrokowy) 👁️",
        "Poprzez działanie (uczeń praktyczny) 👐",
        "Poprzez słuchanie (uczeń słuchowy) 🎧",
        "Poprzez powtarzanie i ćwiczenie 🔄✏️",
      ],
    },
    6: {
      question: "Jak Twoje dziecko zachowuje się podczas pracy w grupie?",
      answers: [
        "Lubi współpracować i dzielić się pomysłami 🤝💡",
        "Woli prowadzić i przejmować odpowiedzialność 🧑‍⚖️",
        "Woli pracować samodzielnie, ale pomaga, gdy trzeba 👤✔️",
        "Czuje się nieśmiałe lub niekomfortowo w grupie 😳",
      ],
    },
    7: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/quiz_br_2.webp",
      subtitle:
        "Oferujemy zarówno indywidualny, jak i grupowy format nauki, a także bierzemy pod uwagę wiek dzieci, aby jak najlepiej dostosować proces do każdego dziecka.",
      button: "Zaczynajmy!",
    },
    8: {
      question: "W szkole, co Twoje dziecko lubi najbardziej?",
      answers: [
        "Eksperymenty naukowe lub wyzwania matematyczne 🧪🔢",
        "Czytanie i pisanie opowiadań 📚✍️",
        "Sztuka, muzyka lub twórcze zajęcia 🎨🎶",
        "Wychowanie fizyczne lub sport 🏃‍♀️🏋️‍♂️",
        "Inne 🙂",
      ],
    },
    9: {
      question:
        "Czy Twoje dziecko wykazało zainteresowanie nauką programowania?",
      answers: [
        "Tak, już zaczęło się uczyć 💻🚀",
        "Tak, są ciekawe, ale jeszcze nie próbowały 🤔💡",
        "Jeszcze nie, ale mogą być zainteresowane 🤷‍♂️",
        "Nie, nie są zainteresowane 🙅‍♀️",
      ],
    },
    10: {
      title: "Gratulacje!",
      typeInfo: "congrats",
      subtitle:
        "W Kodland uczniowie projektują modele 3D, tworzą komiksy, budują gry i rozwijają programy komputerowe. Obecnie 30 000 dzieci na całym świecie uczy się z nami!",
      button: "Prawie skończyliśmy 🎉",
    },
    11: {
      title: "Uzupełnij dane kontaktowe, aby uzyskać dostęp do darmowego kursu",
      type: "one-page-contacts",
      subtitle: "",
      button: "Prawie skończone 🔥",
    },
    12: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    13: {
      title: "Przejrzyj te informacje, aby zakończyć rejestrację ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Pamiętaj, że do lekcji będziesz potrzebować działającego komputera stacjonarnego lub laptopa i musisz towarzyszyć swojemu dziecku przez cały czas trwania zajęć. Pamiętaj, że zajęcia są indywidualne i spersonalizowane.",
      button: "Co jeszcze?",
    },
    14: {
      title:
        "Przed zajęciami próbnymi sprawdź swoją skrzynkę e-mail i WhatsApp 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Na 24 godziny przed zajęciami wyślemy przypomnienie, a na 2 godziny przed zajęciami poprosimy o potwierdzenie obecności. Bardzo ważne jest, abyśmy pozostali w kontakcie, aby zajęcia nie zostały odwołane.",
      button: "Co jeszcze?",
    },
    15: {
      title: "Lekcja odbędzie się na naszej platformie 💻",
      typeInfo: "classroom",
      subtitle:
        "Otrzymasz link i unikalny kod przez WhatsApp oraz e-mail. Wystarczy kliknąć w link, a przeniesie Cię on prosto do lekcji. Bez dodatkowych aplikacji, bez pobierania.",
      button: "Rozumiem ✅",
    },
  },
};
